import React, { useCallback, useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import topNftStyles from "./scss/nft-details.module.scss";
import Mint from "./Mint";
import NewCollection from "./NewCollection";
import NFTs from "./NFTs";
import TopCollection from "./TopCollection";
import TimeFrame from "../Filters/TimeFrame";

const TopNFT = () => {
  const [key, setKey] = useState("collection");
  const [timeFrame, setTimeFrame] = useState("24H");
  const changeTimeFrame = useCallback(
    (value) => {
      setTimeFrame(value);
    },
    [timeFrame]
  );
  const [title, setTitle] = useState("Top Collections");

  useEffect(() => {
    switch (key) {
      case "collection":
        setTitle("Top Collections");
        break;
      case "nft":
        setTitle("Top NFT's");
        break;
      case "mint":
        setTitle("Top Mints");
        break;
      case "new":
        setTitle("New Collections");
        break;
      default:
        setTitle("");
    }
  }, [key]);

  return (
    <main className="float-top position-relative">
      <section>
        <div className="container">
          <div className={topNftStyles.siteTable}>
            <div className="header-before">
              <div className={`${topNftStyles.tbaleHead}`}>
                <h3>{title}</h3>
              </div>
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey={key}
                transition={true}
                onSelect={(k) => {
                  setKey(k);
                }}
                unmountOnExit={true}
              >
                <div className="tab-btn-group2 pb">
                  <div className="d-flex w-100 justify-content-between align-items-center">
                    <Nav>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="collection"
                          className="tab-btn-light"
                        >
                          Collection
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="nft" className="tab-btn-light">
                          NFT
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="mint" className="tab-btn-light">
                          Mint
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="new" className="tab-btn-light">
                          New
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <TimeFrame
                      timeFrame={timeFrame}
                      setTimeFrame={changeTimeFrame}
                    />
                  </div>
                </div>

                <Tab.Content>
                  <Tab.Pane eventKey="collection">
                    <TopCollection timeFrame={timeFrame} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="nft">
                    <NFTs timeFrame={timeFrame} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="mint">
                    <Mint timeFrame={timeFrame} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="new">
                    <NewCollection timeFrame={timeFrame} />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TopNFT;
